import {
  PATH_PACKAGE_TRACKING,
  PATH_PACKAGE_TRACKING_STATUS
} from 'tracker.routes';

const getPublicTrackerPathname = (trackingKey, companyHash) => {
  if (!trackingKey || !companyHash) {
    return PATH_PACKAGE_TRACKING;
  }
  return PATH_PACKAGE_TRACKING_STATUS.replace(
    ':companySecretId',
    companyHash
  ).replace(':trackingKey', trackingKey);
};

export default getPublicTrackerPathname;
